import React from "react";
import Logo from "../Assets/Images/Logo";
import "../Assets/Styles/test-landing.css";
import "../Assets/Styles/theme-bridge.css";

/**
 * Shared test-landing structure — the IELTS landing page's skeleton
 * (slim logo header → hero: badge / title / subtitle / CTA → banner image)
 * re-usable for the Arabic RTL test pages. Each page supplies its OWN
 * content through props.
 *
 * Direction comes from the `dir` prop; the stylesheet uses logical
 * properties, so dir="rtl" mirrors the whole layout (text right, image
 * left) with no extra CSS.
 *
 * The partner-logo slider that used to close this page was removed on
 * request, along with its twin on the IELTS landing page.
 */

const TestLanding = ({
  dir = "rtl",
  headerRight = null,
  badge,
  title,
  subtitle,
  ctaLabel,
  onStart,
  image,
  imageNode,
  imageAlt = "",
  imageSrcSet,
  imageSizes,
  imageWidth,
  imageHeight,
}) => {
  return (
    <div className="tland" dir={dir} lang={dir === "rtl" ? "ar" : "en"}>
      <div className="tland__main">
        <header className="tland__header">
          <Logo />
          {headerRight}
        </header>

        <div className="tland__hero">
          <div className="tland__left">
            {badge && (
              <div className="tland__badge">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="10" fill="#1E5BFF" />
                  <path
                    d="m7.6 12.4 3 3 5.8-6.6"
                    stroke="#fff"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span>{badge}</span>
              </div>
            )}

            <h1 className="tland__title">{title}</h1>

            <p className="tland__sub">{subtitle}</p>

            <button type="button" className="tland__cta" onClick={onStart}>
              {ctaLabel}
            </button>
          </div>

          <div className="tland__right">
            {/*
              imageNode is the preferred form and is what the aptitude and
              career pages pass: an inline SVG component, which costs no
              request at all and paints with the rest of the markup.

              The raster branch is for pages that have a photographic or
              rendered illustration that SVG cannot express. When it is used
              it is the largest thing above the fold, so it is eager and high
              priority — never lazy, which would deliberately hold back the
              one image the page is judged on. Callers should pass
              imageWidth/imageHeight so the box holds its space and the text
              beside it does not jump when the image arrives.

              Guarded on `image` so a caller that supplies neither renders
              nothing, rather than a broken <img> with an undefined src.
            */}
            {imageNode ||
              (image ? (
                <img
                  className="tland__banner"
                  src={image}
                  srcSet={imageSrcSet}
                  sizes={imageSizes}
                  width={imageWidth}
                  height={imageHeight}
                  loading="eager"
                  fetchpriority="high"
                  decoding="async"
                  alt={imageAlt}
                />
              ) : null)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestLanding;
